export default __webpack_public_path__ + "static/media/bg-excelencia.0ec5f943.png";